import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import { TableColumn, Button, TableRow, FontIcon } from 'react-md';
import cn from 'classnames';

import { invokeBackendApi } from '../../libs/awsLib';
import LoaderButton from '../LoaderButton';
import KebabMenu from '../KebabMenu';
import ContestDialog from './ContestDialog';
import PsyActionsColumn from '../Contested/PsyActions';

export default injectIntl(class SegmentRow extends PureComponent {
    static propTypes = {
      intl: intlShape.isRequired,
      segment: PropTypes.object.isRequired,
      userAttributes: PropTypes.shape({
        isPsy: PropTypes.bool.isRequired,
      }),
      onSegmentClick: PropTypes.func.isRequired,
      activeSegment: PropTypes.object,
      selected: PropTypes.bool.isRequired,
      isLoading: PropTypes.bool,
      isAccepted: PropTypes.bool,
      isReported: PropTypes.bool,
      isRejected: PropTypes.bool,
    };

    state = {
      reported: false,
      accepted: false,
      rejected: false,
      isLoading: false,
    };

    handleClickReportError = (segment, errorType, errorReason) => {
      // console.log('segmentClicked : ', segment);
      this.setState({ isLoading: true });
      const {
        userAttributes: { isPsy },
      } = this.props;
      const action = isPsy ? 'accept' : 'report';
      const path = `/segments/${segment.segmentId}/${action}`;
      const body = { errorType, errorReason };

      invokeBackendApi({ path, method: 'POST', body }).then(() => {
        this.setState({ isLoading: false, [`${action}ed`]: true });
      });
    };

    render() {
      const {
        segment,
        userAttributes,
        userAttributes: { isPsy },
        intl,
        onSegmentClick,
        activeSegment,
        selected,
        isLoading: isLoadingProps,
        isAccepted,
        isReported,
        isRejected,
        ...restOfProps
      } = this.props;
      const {
        reported, accepted, rejected, isLoading,
      } = this.state;

      let lastColumn = null;
      if (isLoading || isLoadingProps) {
        lastColumn = (
          <TableColumn>
            <LoaderButton
              icon
              className="md-btn--icon-xmini"
              isLoading={isLoading}
            />
          </TableColumn>
        );
      } else if (segment.segmentState === 'ACCEPTED' || accepted || isAccepted) {
        lastColumn = (
          <TableColumn>
            <Button className="md-btn--icon-xmini" icon primary swapTheming>
              done
            </Button>
          </TableColumn>
        );
      } else if (segment.segmentState === 'REJECTED' || rejected || isRejected) {
        lastColumn = (
          <TableColumn>
            <Button
              className="md-btn--icon-xmini icon-rejected"
              icon
              swapTheming
            >
              priority_high
            </Button>
          </TableColumn>
        );
      } else if (segment.segmentState === 'REPORTED' || reported || isReported) {
        if (isPsy) {
          lastColumn = <PsyActionsColumn segment={segment} isLoading={isLoadingProps} isAccepted={isAccepted} isRejected={isRejected} />;
        } else {
          lastColumn = (
            <TableColumn>
              <Button className="md-btn--icon-xmini" disabled icon swapTheming>
                    hourglass_empty
              </Button>
            </TableColumn>
          );
        }
      } else {
        const menuItems = [
          <ContestDialog
            key={1}
            segment={segment}
            onClickReportError={this.handleClickReportError}
            userAttributes={userAttributes}
          />,
        ];
        lastColumn = <KebabMenu menuItems={menuItems} />;
      }
      return (
        <TableRow
          key={segment.start}
          className={cn(
            segment.segmentState === 'ACCEPTED'
              ? 'noOverSpeed'
              : segment.overspeed,
            { 'md-table-row--active': activeSegment === segment }
          )}
          onClick={() => onSegmentClick(segment)}
          selectable={
            segment.segmentState !== 'ACCEPTED' &&
            segment.segmentState !== 'REJECTED' &&
            !isLoading && !accepted && !rejected && !isLoadingProps && !isAccepted && !isRejected &&
            (isPsy || (segment.segmentState !== 'REPORTED' && !reported && !isReported))
          }
          selected={selected}
          {...restOfProps}
        >
          {(
            <React.Fragment>
              {(segment.segmentState === 'ACCEPTED' ||
                segment.segmentState === 'REJECTED' ||
                isLoading || accepted || rejected || isLoadingProps || isAccepted || isRejected ||
                (!isPsy && (segment.segmentState === 'REPORTED' || reported || isReported))) && <TableColumn />}
              <TableColumn>{Math.round(segment.avg)}km/h</TableColumn>
              <TableColumn>{segment.limit}km/h</TableColumn>
              <TableColumn>{intl.formatTime(segment.start)}</TableColumn>
              <TableColumn tooltipLabel={segment.formatted_address}>
                <div className="ellipsis">{segment.formatted_address}</div>
              </TableColumn>
              <TableColumn tooltipLabel={segment.GPSFixes}>
                <FontIcon>wifi</FontIcon>
              </TableColumn>
              {lastColumn}
            </React.Fragment>)}
        </TableRow>
      );
    }
});



// WEBPACK FOOTER //
// ./src/components/Journey/SegmentRow.js